import { ObraHechoIrregular } from './ObraHechoIrregular';

export class FurXObraPublicaXHi {
    nfurxobpxhiId: number;
    nfurxobpxhiIdfurxobp: number;
    nfurxobpxhiIdhi: number;
    cfurxobpxhiDschi: string;
    cfurxobpxhiFlgnuevo = 'NO';

    // hechoIrregular : ObraHechoIrregular;
    obraPublicaPorHechoIrregular: ObraHechoIrregular;
}

